<script>
import { mapGetters } from 'vuex'
import { InvitationStatus } from '@/enums/InvitationStatus'
import InvitationDetails from './InvitationDetails.vue'
export default {
  components: {
    InvitationDetails
  },
  props: {
    token: {
      type: String,
      default: ''
    },
    tokenDecoded: {
      type: Object
    }
  },
  data: vm => ({
    invitationStatusEnum: InvitationStatus,
    invitationStatus: 'error', // initial-state
    loading: false,
    dialog: {
      state: false,
      [InvitationStatus.Expired]: {
        color: 'error',
        title: vm.$t('global.the.error'),
        message: vm.$t('component.profile.administrationManagement.invite.expired'),
        relocation: 'dashboard'
      },
      [InvitationStatus.Accepted]: {
        color: 'success',
        title: vm.$t('global.successful'),
        message: vm.$t('component.profile.administrationManagement.invite.accepted', {
          '{{OrganizationName}}': vm.tokenDecoded.OrganizationName
        }),
        relocation: 'logout'
      },
      [InvitationStatus.Rejected]: {
        color: 'secondary',
        title: vm.$t('global.successful'),
        message: vm.$t('component.profile.administrationManagement.invite.rejected'),
        relocation: 'dashboard'
      },
      error: {
        color: 'error',
        title: vm.$t('global.the.error'),
        message: vm.$t('global.save.error'),
        relocation: ''
      }
    }
  }),
  computed: {
    ...mapGetters(['isAuthenticated', 'locale'])
  },
  methods: {
    async join(status) {
      this.loading = true
      await this.$organizationService
        .join({
          data: {
            status: status
          },
          token: this.token
        })
        .then(response => {
          if (response.status === 200) this.invitationStatus = status
          else this.invitationStatus = 'error'
        })
        .catch(e => {
          if (e.response.status === 401)
            this.invitationStatus = this.invitationStatusEnum.Expired
          else this.invitationStatus = 'error'
        })
        .finally(() => {
          this.loading = false
          this.dialog.state = true
        })
    },
    relocate(location) {
      if (location) {
        this.$router.push({
          name: this.isAuthenticated ? location : 'login',
          params: { locale: this.locale }
        })
      } else {
        this.dialog.state = false
      }
    }
  }
}
</script>
<template>
  <div>
    <v-dialog v-model="dialog.state" max-width="500" persistent>
      <v-card>
        <DialogBaseColoredTitle :color="dialog[invitationStatus].color">{{
            dialog[invitationStatus].title
          }}</DialogBaseColoredTitle>
        <v-divider></v-divider>
        <DialogBaseText>
          <span v-html="dialog[invitationStatus].message" />
        </DialogBaseText>
        <v-divider></v-divider>
        <DialogBaseActions>
          <v-btn
            elevation="4"
            :color="dialog[invitationStatus].color"
            class="white--text ml-0 px-8 py-2"
            @click="relocate(dialog[invitationStatus].relocation)"
          >{{ $t('button.ok') }}</v-btn>
        </DialogBaseActions>
      </v-card>
    </v-dialog>
    <v-card width="500" :disabled="dialog.state">
      <DialogBaseText>
        <InvitationDetails :token-decoded="tokenDecoded" />
      </DialogBaseText>
      <v-divider></v-divider>
      <DialogBaseText class="text-left">
        <span class="error--text" v-html="$t('component.profile.administrationManagement.admin.warning')"> </span>
      </DialogBaseText>
      <v-divider></v-divider>
      <DialogBaseActions>
        <v-btn
          :loading="loading"
          color="error"
          class="white--text px-8 py-2"
          @click="join(invitationStatusEnum.Rejected)"
        ><span>{{ $t('button.reject') }}</span></v-btn>
        <v-spacer></v-spacer>
        <v-btn
          :loading="loading"
          color="primary"
          class="white--text px-8 py-2"
          @click="join(invitationStatusEnum.Accepted)"
        ><span>{{ $t('button.approve') }}</span></v-btn>
      </DialogBaseActions>
    </v-card>
  </div>
</template>
